import React from "react";

export default class InputTextIcon extends React.Component {
  render() {
    const { icon,cls, ...inputProps } = this.props;
    return (
      <div className={"input-text-icon " + (cls || "")}>
        {icon && <img src={'/images/icons/' + icon} className="input-icon" alt="icon" />}
        <input type="text" {...inputProps} />
      </div>
    );
  }
}